export interface TicketCategory {
  name: string;
  color: string; // Hex color code
  rgb: [number, number, number]; // RGB values for PDF generation
}

export const TICKET_CATEGORIES: TicketCategory[] = [
  { name: 'Full Access', color: '#7C4DFF', rgb: [124, 77, 255] }, // Purple
  { name: 'Media', color: '#00BCD4', rgb: [0, 188, 212] }, // Cyan
  { name: 'F&B', color: '#FF9800', rgb: [255, 152, 0] }, // Orange
  { name: 'Sponsor', color: '#4CAF50', rgb: [76, 175, 80] }, // Green
  { name: 'Management', color: '#2196F3', rgb: [33, 150, 243] }, // Blue
  { name: 'Ushers', color: '#9C27B0', rgb: [156, 39, 176] }, // Purple
  { name: 'Security', color: '#F44336', rgb: [244, 67, 54] }, // Red
  { name: 'Booth', color: '#FFC107', rgb: [255, 193, 7] }, // Amber
  { name: 'Cleaning', color: '#607D8B', rgb: [96, 125, 139] } // Blue Grey
];

export function getCategoryByName(name: string): TicketCategory | undefined {
  return TICKET_CATEGORIES.find(cat => cat.name === name);
}

export function getCategoryColor(name: string): string {
  const category = getCategoryByName(name);
  return category?.color || '#7C4DFF'; // Default purple
}

export function getCategoryRGB(name: string): [number, number, number] {
  const category = getCategoryByName(name);
  return category?.rgb || [124, 77, 255]; // Default purple
}
